import { Capacitor } from "@capacitor/core";

/**
 * RevenueCat SDK keys are PUBLIC (safe to ship in the app binary).
 * Do NOT store these in VITE_* env vars for Lovable projects.
 */
export const REVENUECAT_SDK_KEYS = {
  ios: "appl_RduMZaRzKWozKeYyTqtZeMAaSft",
  // If you ever reuse this repo for Android, set your Android SDK key here (starts with "goog_")
  android: "",
} as const;

/**
 * Platform-specific RevenueCat offering identifiers.
 * These must match the identifiers configured in RevenueCat dashboard.
 */
export const REVENUECAT_OFFERING_IDS = {
  ios: "Pro apple",    // iOS offering identifier in RevenueCat
  android: "default",  // Android offering identifier in RevenueCat
} as const;

export const getRevenueCatApiKey = (): string | null => {
  if (!Capacitor.isNativePlatform()) return null;

  const platform = Capacitor.getPlatform();
  if (platform === "ios") return REVENUECAT_SDK_KEYS.ios || null;
  if (platform === "android") return REVENUECAT_SDK_KEYS.android || null;
  return null;
};

export const getRevenueCatOfferingId = (): string | null => {
  if (!Capacitor.isNativePlatform()) return null;

  const platform = Capacitor.getPlatform();
  if (platform === "ios") return REVENUECAT_OFFERING_IDS.ios;
  if (platform === "android") return REVENUECAT_OFFERING_IDS.android;
  return null;
};
